<template>
    <div class="col-12 bg-white q-pa-sm">
        <q-btn-group spread outline class="q-ma-xs">
            <q-btn
                unelevated
                color="primary"
                :outline="shippingType != ShippingType.DELIVERY"
                label="DELIVERY"
                icon="local_shipping"
                @click="onTapDeliveryBtn"
            >
            </q-btn>
            <q-btn
                unelevated
                color="primary"
                :outline="shippingType != ShippingType.PICKUP"
                label="PICKUP"
                icon="shopping_basket"
                @click="onTapPickupBtn"
            >
            </q-btn>
        </q-btn-group>
    </div>
</template>

<script>
import { ShippingType } from "@/entities/order/order";
import { mapState } from "vuex";
export default {
    name: "ShippingType",
    data() {
        return {
            ShippingType: ShippingType,
        };
    },
    computed: {
        ...mapState({
            shippingType: (state) => state["checkout"]["shippingType"],
        }),
    },
    methods: {
        async onTapPickupBtn() {
            await this.$store.dispatch("checkout/setShippingType", ShippingType.PICKUP);
            await this.$store.dispatch("checkout/updateDraftOrder");
            await this.$store.dispatch("checkout/getCost");
        },
        async onTapDeliveryBtn() {
            await this.$store.dispatch("checkout/setShippingType", ShippingType.DELIVERY);
            await this.$store.dispatch("checkout/updateDraftOrder");
            await this.$store.dispatch("checkout/getCost");
        },
    },
};
</script>
